var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 38,
    viewBox: "0 0 53 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 48099076"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M26.7035 34.4893C18.5725 39.8103 7.95285 39.0142 0.90476 32.5669C-1.86888 23.323 1.89264 13.1471 10.0236 7.82609C18.1546 2.50509 28.7741 3.3013 35.8222 9.74864C38.5959 18.9924 34.8534 29.1683 26.7035 34.4893Z",
    fill: "url(#paint0_linear_6_404)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    opacity: 0.5,
    d: "M4.79897 34.2564C7.03379 34.2564 8.84546 32.4044 8.84546 30.1199C8.84546 27.8355 7.03379 25.9835 4.79897 25.9835C2.56418 25.9835 0.752502 27.8355 0.752502 30.1199C0.752502 32.4044 2.56418 34.2564 4.79897 34.2564Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M33.5043 24.4689C31.7185 33.0136 23.4736 38.4511 15.1337 36.6256C12.3221 36.0042 9.87139 34.6449 7.89565 32.8C4.00116 29.1296 2.0444 23.5173 3.24126 17.8467C5.02702 9.3021 13.272 3.8646 21.6119 5.69004C24.2145 6.27263 26.5323 7.47666 28.432 9.14675C28.584 9.28269 28.7359 9.41862 28.8689 9.55457C32.7634 13.2055 34.7011 18.8177 33.5043 24.4689Z",
    fill: "url(#paint1_linear_6_404)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    opacity: 0.5,
    d: "M31.9653 16.3513C34.2001 16.3513 36.0118 14.4995 36.0118 12.215C36.0118 9.93047 34.2001 8.07854 31.9653 8.07854C29.7305 8.07854 27.9188 9.93047 27.9188 12.215C27.9188 14.4995 29.7305 16.3513 31.9653 16.3513Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M28.8879 9.53507C21.8969 8.05917 14.8107 11.613 11.7331 18.0604C8.76954 24.2552 10.1374 31.8289 15.1337 36.6061C12.3221 35.9847 9.87139 34.6253 7.89565 32.7804C4.00116 29.1102 2.0444 23.4978 3.24126 17.8273C5.02702 9.28261 13.272 3.8451 21.6119 5.67055C23.9486 6.17547 26.0383 7.3989 26.0383 7.3989C27.2921 8.13685 28.242 8.93306 28.8879 9.53507Z",
    fill: "url(#paint2_linear_6_404)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M40.8187 4.87435C40.3628 6.75805 39.2039 8.29221 37.855 8.77771C36.9052 7.70962 36.5823 5.78707 37.0382 3.90336C37.4942 2.01965 38.6531 0.485491 40.0018 0C40.9517 1.06808 41.2747 2.99064 40.8187 4.87435Z",
    fill: "url(#paint3_linear_6_404)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M44.8842 14.9142C41.7497 14.118 39.2039 12.0984 38.387 9.768C40.1728 8.09791 43.3454 7.55416 46.48 8.35036C49.6145 9.14657 52.1603 11.1662 52.9772 13.4966C51.2104 15.1472 48.0188 15.7104 44.8842 14.9142Z",
    fill: "url(#paint4_linear_6_404)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6_404",
    x1: 8.77116,
    y1: 8.70529,
    x2: 28.4967,
    y2: 33.1835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0160547,
    stopColor: "#3A37D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA50BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6_404",
    x1: 31.9566,
    y1: 36.101,
    x2: 12.4061,
    y2: 15.513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA329"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3574,
    stopColor: "#FE7B1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC2A01"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6_404",
    x1: 26.3231,
    y1: 3.81515,
    x2: 6.41821,
    y2: 28.3671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA50BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA329"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6_404",
    x1: 40.0243,
    y1: 0.24778,
    x2: 37.7892,
    y2: 8.03379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0160547,
    stopColor: "#3A37D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA50BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6_404",
    x1: 52.5554,
    y1: 13.519,
    x2: 39.5182,
    y2: 9.93736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0160547,
    stopColor: "#3A37D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA50BF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1270f7f4883261fb872e43b56a3e6c76.svg";
export { ForwardRef as ReactComponent };